export default "__VITE_ASSET__5fa35644__"